import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./adminModules/admin/admin.routes').then((m) => m.ADMIN_ROUTES)
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'business-login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'business-signup',
    loadComponent: () => import('./components/business-signup/business-signup.component').then(m => m.BusinessSignupComponent)
  },
  {
    path: 'business-custom-signup',
    loadComponent: () => import('./components/business-custom-plan-signup/business-custom-plan-signup.component').then(m => m.BusinessCustomPlanSignupComponent)
  },
  {
    path: 'onboarding-notification',
    loadComponent: () => import('./components/onboarding-notification/onboarding-notification.component').then(m => m.OnboardingNotificationComponent)
  },
  {
    path: 'free-transfer',
    loadComponent: () => import('./components/free-transfer/free-transfer.component').then(m => m.FreeTransferComponent)
  },
  {
    path: 'set-password/:oobCode',
    loadComponent: () => import('./components/auth/set-password/set-password.component').then(m => m.SetPasswordComponent)
  },
  {
    path: 'email-verification',
    loadComponent: () => import('./components/auth/emailverification/emailverification.component').then(m => m.EmailverificationComponent)
  },
  {
    path: 'change-subscription',
    loadComponent: () => import('./components/account/subscription/change-subscription/change-subscription.component').then(m => m.ChangeSubscriptionComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'upgrade',
    loadComponent: () => import('./components/upgrade/upgrade.component').then(m => m.UpgradeComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'operation-log',
    loadComponent: () => import('./components/operation-log/operation-log.component').then(m => m.OperationLogComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin-operation-log',
    loadComponent: () => import('./components/operation-log/operation-log.component').then(m => m.OperationLogComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'undo-subscription-cancellation',
    loadComponent: () => import('./components/account/subscription/undo-subscription-cancellation/undo-subscription-cancellation.component').then(m => m.UndoSubscriptionCancellationComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadComponent: () => import('./components/auth/auth.component').then(m => m.AuthComponent)
  },
  {
    path: 'create-transfer',
    loadComponent: () => import('./components/create-transfer/create-transfer.component').then(m => m.CreateTransferComponent),
    canActivate: [AuthGuard]
  },
  // DEMO ROUTES: safe to delete along with src/app/components/demo-upload/
  // and src/app/components/demo-download/
  {
    path: 'demo-upload',
    loadComponent: () => import('./components/demo-upload/demo-upload.component').then(m => m.DemoUploadComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'demo-download',
    loadComponent: () => import('./components/demo-download/demo-download.component').then(m => m.DemoDownloadComponent)
  },
  {
    path: 'manage-transfer',
    loadComponent: () => import('./components/manage-transfer/manage-transfer.component').then(m => m.ManageTransferComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'manage-streaming',
    loadComponent: () => import('./components/manage-streaming/manage-streaming.component').then(m => m.ManageStreamingComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'view-transfer/:id',
    loadComponent: () => import('./components/view-transfer/view-transfer.component').then(m => m.ViewTransferComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-transfer/:id',
    loadComponent: () => import('./components/edit-transfer/edit-transfer.component').then(m => m.EditTransferComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'create-streaming',
    loadComponent: () => import('./components/create-streaming/create-streaming.component').then(m => m.CreateStreamingComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'view-bill/:id/:invoice_type',
    loadComponent: () => import('./components/account/billing/viewbilling/viewbilling.component').then(m => m.ViewbillingComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'view-sms-bill/:id/:invoice_type',
    loadComponent: () => import('./components/account/billing/viewsmsbill/viewsmsbill.component').then(m => m.ViewsmsbillComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'change-default-settings',
    loadComponent: () => import('./components/change-default-settings/change-default-settings.component').then(m => m.ChangeDefaultSettingsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'business-admin-change-default-settings',
    loadComponent: () => import('./components/business-admin-change-default-settings/business-admin-change-default-settings.component').then(m => m.BusinessAdminChangeDefaultSettingsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'subscription',
    loadComponent: () => import('./components/account-management/account-management.component').then(m => m.AccountManagementComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'billing',
    loadComponent: () => import('./components/account-management/account-management.component').then(m => m.AccountManagementComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'sms-log',
    loadComponent: () => import('./components/account-management/account-management.component').then(m => m.AccountManagementComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'user-profile',
    loadComponent: () => import('./components/account-management/account-management.component').then(m => m.AccountManagementComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'custom-branding',
    loadComponent: () => import('./components/custom-branding/custom-branding.component').then(m => m.CustomBrandingComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'setup-own-domain',
    loadComponent: () => import('./components/setup-own-custom-domain/setup-own-custom-domain.component').then(m => m.SetupOwnCustomDomainComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    loadComponent: () => import('./components/account/account.component').then(m => m.AccountComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'add-members',
    loadComponent: () => import('./components/add-file-collection-members/add-file-collection-members.component').then(m => m.AddFileCollectionMembersComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'manage-file-collection',
    loadComponent: () => import('./components/manage-file-collection/manage-file-collection.component').then(m => m.ManageFileCollectionComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'view-collection/:id',
    loadComponent: () => import('./components/manage-file-collection/view-collection/view-collection.component').then(m => m.ViewCollectionComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'page-not-found',
    loadComponent: () => import('./components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
  },
  {
    path: 'server-error',
    loadComponent: () => import('./components/server-error/server-error.component').then(m => m.ServerErrorComponent)
  },
  {
    path: 'my-members',
    loadComponent: () => import('./components/my-members/my-members.component').then(m => m.MyMembersComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'addressbook',
    loadComponent: () => import('./components/addressbook/addressbook.component').then(m => m.AddressbookComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin-addressbook',
    loadComponent: () => import('./components/addressbook/addressbook.component').then(m => m.AddressbookComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'complete-your-profile/:uid/:id',
    loadComponent: () => import('./components/complete-your-profile/complete-your-profile.component').then(m => m.CompleteYourProfileComponent)
  },
  {
    path: 'tc-business-registration',
    loadComponent: () => import('./components/tc-business-registration/tc-business-registration.component').then(m => m.TcBusinessRegistrationComponent)
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    pathMatch: 'full',
    loadComponent: () => import('./components/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
  }
];
